import { AppThunkDispatch } from '..';
import { snackbarActionNames, Notification } from './types';

export const enqueueSnackbarAction = (notification: Notification) => {
  const key = notification.options && notification.options.key;

  return async (dispatch: AppThunkDispatch) => {
    dispatch({
      type: snackbarActionNames.ENQUEUE_SNACKBAR,
      notification: {
        ...notification,
        message: notification.message,
        key: key || Date.now() + Math.random(),
      },
    });
  };
};

export const closeSnackbarAction = (key: string) => async (dispatch: AppThunkDispatch) => {
  dispatch({
    type: snackbarActionNames.CLOSE_SNACKBAR,
    notification: {
      dismissAll: !key,
      key,
    },
  });
};

export const removeSnackbarAction = (key: string) => async (dispatch: AppThunkDispatch) => {
  dispatch({
    type: snackbarActionNames.REMOVE_SNACKBAR,
    notification: {
      dismissAll: !key,
      key,
    },
  });
};
